<template>
    <div class="container-fluid mt-4">
        <div class="container-fluid">
              <div class="row d-flex justify-content-between">
                <div class="col-4">
                  <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="100px"/></span>
                    <span v-else><img src="@/assets/images/logo.png" height="50px"/></span><br>
                    <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
                    <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
                    <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br>
                    <span style="color:black;font-size:13px">Email : {{ userData.email }}</span><br>
                    <span style="color:black;font-size:13px">Website : {{ userData.website }}</span><br>
                    <span v-if="userData.slogan" style="color:black;font-size:13px;font-style:italic">Slogan: {{ userData.slogan }}</span><br>

                </div>
                <div class="col-5">
                    <img class="img-rounded" src="@/assets/images/sick.png" height="50px" /><br>
                    <!-- <table v-for="item in patients" :key="item.id" class="table" density="compact" style="color:black">
                    <tr><td>Full Name </td><td> {{ item.name }}</td></tr>
                    <tr><td>Gender </td><td> {{ item.gender }} </td></tr>
                    <tr><td> Telephone </td><td> 0{{ item.telephone }} </td></tr>
                    <tr><td> Age </td><td> {{ getAge(item.date_of_birth) }}  </td></tr>
                    <tr><td> Address </td><td> {{ item.address }} </td></tr>
                  </table> -->
                  <table class="table">
                      <tr><td> Name </td><td> <b class="text-primary h7">{{ groups.acc_name}} </b></td></tr>
                </table>
                </div>
              </div>
              </div>
          <h4 class="mt-2 text-center text-decoration-underline">Payment details</h4>
              
            <div class="container-fluid">
                <div v-if="userData && userData.settings && userData.settings.print_trans == '1'">
                      <span v-if="ledger.length">
            <!-- <h4 class="mt-3" style="color:black">Patient Visits</h4> -->
            <table class="table table-sm mt-2" style="color: black;" density="compact">
                        <thead><tr><th> ID</th><th> Name</th><th>Category</th><th>Service Name</th><th>Service Price</th><th>Prescription</th></tr></thead>
                        <tbody>
                          <tr v-for="item in ledger" :key="item.id">
                              <td>{{ item.patient_id }} </td>
                              <td>{{ item.patient_name }} </td>
                              <td>{{ item.service_category }} </td>
                              <td>{{ item.service_name }}</td>
                              <td>{{ item.price }}</td>
                              <td>{{  item.prescription }}</td>
                          </tr>
                        </tbody>
                        </table>
                        </span>
                    </div>
                    <div v-else>
                      <span v-if="ledger.length">
                      <h5>Details</h5>
                        <table class="table table-sm mt-2" style="color: black;" density="compact">
                        <thead><tr><th> ID</th><th> Name</th><th>Category</th><th>Service Name</th><th>Service Price</th><th>Prescription</th></tr></thead>
                        <tbody>
                          <tr v-for="item in ledger" :key="item.id">
                              <td>{{ item.patient_id }} </td>
                              <td>{{ item.patient_name }} </td>
                              <td>{{ item.service_category }} </td>
                              <td>{{ item.service_name }}</td>
                              <td>{{ commas(item.price) }}</td>
                              <td>{{  item.prescription }}</td>
                          </tr>
                        </tbody>
                        </table>
                      </span>
        
           
            
       
        </div>
        <div class="d-flex justify-content-between">
                        <span class="h5 text-black"> Total Amount: <span class="text-primary h2">{{ commas(totalAmountPrice) }}</span></span>
                        
                      </div>
            </div>
            <div class="mt-3 text-center">
                <h5 style="color: black;" class="my-4 text-center">Signature : .........................</h5>
                <p style="color:black;font-size:13px">Printed by : {{ userData.username }}
                <br> Printed Via Afrimed Software
                <br> www.afrimed.com </p>
            </div>
        </div>
</template>

<script>
import axios from "axios";
//   import PageHeader from "@/components/page-header";
//   import appConfig from "@/app.config";
// import { paymentoptionComputed, paymentoptionMethods, groupaccountMethods, groupaccountComputed,groupaccountinvoiceMethods, groupaccountinvoiceComputed } from "@/state/helpers";



  export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patients:[],
      visits:[],
      triages:[],
      appointments:[],
      prescriptions:[],
      payments:[],
      insurances:[],
        companyid:'',
        ledger:[],
        ledgers:[],
        groups:[],
        acc_name:'',
    };
  
  },
  created() {
    this.showpatient();
    this.showvisits();
    this.showtriages();
    this.showappointments();
    this.showprescriptions();
    this.showpayments();
    // this.fetchGroupAccounts();
      this.fetchInfo();
  },
  computed: {
      
    totalServicePrice() {
      return this.ledger.reduce((total, item) => total + Number(item.price || 0), 0);
    },
    totalPresciptionsPrice() {
      return this.ledger.reduce((total, item) => total + Number(item.prescription || 0), 0);
    },
    totalAmountPrice() {
      return this.totalServicePrice + this.totalPresciptionsPrice;
    }
  },
  methods: {
    // getAge(dateString){
    //   let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
    //   return now.getFullYear() - birth.getFullYear() - beforeBirth;
    // },
    getAge(dateString) {
  let birth = new Date(dateString);
  let now = new Date();

  let years = now.getFullYear() - birth.getFullYear();
  let months = now.getMonth() - birth.getMonth();

  // Adjust years and months if the current month hasn't reached the birth month yet
  if (months < 0) {
    years--;
    months += 12;
  }

  // Adjust months if the current day hasn't reached the birth day yet
  if (now.getDate() < birth.getDate()) {
    months--;
    if (months < 0) {
      years--;
      months += 12;
    }
  }

  if (years > 0) {
    // return `${years} years and ${months} months old`;    

    return `${years} years `;

  } else {
    return `${months} months old`;
  }
},
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    async showpatient(){
      this.patient_id=this.$route.query.id;
      let url = `/patientprofile/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.patients = response.data.patients;
      });
    },
    async showvisits(){
      // this.patient_id=this.$route.query.id;
      // let url = `/profilevisits/${this.patient_id}`;
      this.visit_id=this.$route.query.visit_id;
      let url = `/insuranceprofilevisits/${this.visit_id}`;
      await axios.get(url).then((response) => {
        this.visits = response.data.visits;
      });
    },
    commas(x) { return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
  
      
  async fetchInfo(){
    this.id=this.$route.query.id;
    let url = `/accountledger/${this.id}`;
    await axios.get(url).then((response) => {
      this.ledger = response.data.ledgers;
      if (response.data.ledgers.length > 0) {
      this.groups = response.data.ledgers[0].group;
    }
      // this.showgroup();
      
    });
  },
    async showtriages(){
      this.patient_id=this.$route.query.id;
      let url = `/profiletriages/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.triages = response.data.triages;
      });
    },
    async showappointments(){
      this.patient_id=this.$route.query.id;
      let url = `/patientappointment/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.appointments = response.data.appointments;
      });
    },
    async showprescriptions(){
      this.patient_id=this.$route.query.id;
      let url = `/profileprescriptions/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.prescriptions = response.data.prescriptions;
      });
    },
    async showpayments(){
      this.patient_id=this.$route.query.id;
      let url = `/profilepayments/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.payments = response.data.debts;
      });
    },
  },
  mounted() {
    setTimeout(() => {
        window.print();
        window.onafterprint=this.$router.go(-1);
    }, 5800);
},
};
</script>